
    import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
    import './_loader.less';

    @Component({})

    export default class loader extends Vue {

    }
